// API UTIL
// special purpose util which parses incoming API properties

const apiUtil = {
    toUpperCase,
    toTitleCase,
    arrayToJoinedString,
    CEtoFacility,
    toPhoneNumber,
    toZipCode,
};

function toUpperCase(val: any): string {
    return typeof val === 'string' ? val.toUpperCase() : '';
}

function toTitleCase(str: any): string {
    if (typeof str !== 'string') {
        return '';
    }
    return str.replace(/\w\S*/g, text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase());
}

function arrayToJoinedString(val: any, delimiter: string): string {
    if (Array.isArray(val) && val.length > 0) {
        return val.join(delimiter);
    }
    return '';
}

function CEtoFacility(val: string): string {
    if (val === 'CE') {
        return 'FACILITY';
    }
    return val;
}

function toPhoneNumber(phoneNumberString: string | number): string {
    const cleaned = ('' + phoneNumberString).replace(/[^0-9]+/g, '');
    let latest: string;

    if (cleaned.length > 10) {
        latest = cleaned.slice(0, 3) + '-' + cleaned.slice(3, 6) + '-' + cleaned.slice(6, 10);
        return latest;
    } else if (cleaned.length > 6) {
        latest = cleaned.slice(0, 3) + '-' + cleaned.slice(3, 6) + '-' + cleaned.slice(6);
        return latest;
    } else if (cleaned.length > 3) {
        latest = cleaned.slice(0, 3) + '-' + cleaned.slice(3);
        return latest;
    }
    return cleaned;
}

function toZipCode(zipCodeString: string | number): string {
    const cleaned = ('' + zipCodeString).replace(/[^0-9]+/g, '');

    if (cleaned.length > 5) {
        return cleaned.slice(0, 5) + '-' + cleaned.slice(5, 9);
    }
    return cleaned.slice(0, 9);
}

export default apiUtil;
